//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ReferralHero',
  components: {
    ReferralStartEarningBtn: () => import('./ReferralStartEarningBtn.vue'),
  },
  data() {
    return {
      exploreSomethingNewImg: 'https://static.moele.me/img/channels2022/referral/referral-boy.png?auto=format&w=1234',
    };
  },
};
